<template>
    <div class="dynamic-content">
        <div v-if="!loaded">
            <loading-indicator message='Retrieving Terms &amp; Conditions' v-if="!loaded"></loading-indicator>
        </div>
        <div v-if="loaded">
            <div v-if="!found">
                <h1>Not Found</h1>
                <div class="row ">
                    <div class="columns small-12">
                        <p>
                            Terms & Conditions were not found for this code. Please check it one more time. If you still get an error, please email our support team at
                            <a href="mailto:EssilorEvaluationProductSupport@essilorusa.com?subject=Invalid redemption code">EssilorEvaluationProductSupport@essilorusa.com</a>
                        </p>
                    </div>
                </div>
            </div>
          <div v-else>
                <h1>Terms &amp; Conditions</h1>
                <div class="row ">
                    <div class="columns small-12">
                       <div  class="terms" v-html="termsContent"></div> <br>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
</template>
<script>
import LoadingIndicator from "@/components/layout/LoadingIndicator";
import Vue from "vue";
export default {
  components: { LoadingIndicator },
  props: ["code"],
  data() {
    return {
      loaded: false,
      found: false,
      coupon: null,
      termsContent: ""
    };
  },
  methods: {
    handleError() {
      this.$router.replace("/error/");
    },
    loadCouponData() {
      axios
        .get("/status/" + this.code)
        .then(response => {
          this.coupon = response.data;
          this.loadTerms();
        })
        .catch(error => {
          if (error.response && error.response.status == 404) {
            this.found = false;
            this.loaded = true;
          } else {
            this.handleError(error);
          }
        });
    },

    loadTerms() {
      axios
        .get(Vue.config.HOST_URL + this.coupon.programDetails.termsPageName, {
          responseType: "text"
        })
        .then(response => {
          this.termsContent = response.data;
          this.found = true;
          this.loaded = true;
        })
        .catch(error => {
          this.handleError(error);
        });
    }
  },

  created() {
    this.loadCouponData(this.code);
  }
};
</script>
<style>
.terms {
  text-align: left;
  margin: auto;
  padding: 5px;
}

.terms p,
.terms ul li {
  font-size: smaller;
}

.termslabel {
  font-size: 12pt;
}

.termscheck {
  font-size: 12pt;
}
</style>
